
(function dateTimePickerDirectiveDefinition() {

    'use strict';

    function createDateTimePickerFactory(small) {
        return function dateTimePickerDirectiveFactory() {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    ngModel: '=',
                    ngChange: '&',
                    dayFormat: "=",
                    monthFormat: "=",
                    yearFormat: "=",
                    dayHeaderFormat: "=",
                    dayTitleFormat: "=",
                    monthTitleFormat: "=",
                    showWeeks: "=",
                    startingDay: "=",
                    yearRange: "=",
                    dateFormat: "=",
                    minDate: "=",
                    maxDate: "=",
                    dateOptions: "=",
                    dateDisabled: "&",
                    hourStep: "=",
                    minuteStep: "=",
                    showMeridian: "=",
                    meredians: "=",
                    mousewheel: "=",
                    placeholder: "=",
                    clearText: "@",
                    showClear: "@",
                    datePartClass: "@",
                    timePartClass: "@",
                    updatePromise: "=?",
                    dateLoading: "=?"
                },
                template: function (elem, attrs) {
                    function dashCase(name, separator) {
                        return name.replace(/[A-Z]/g, function (letter, pos) {
                            return (pos ? '-' : '') + letter.toLowerCase();
                        });
                    }
                    
                    function createAttr(innerAttr, dateTimeAttrOpt) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + dateTimeAttr + "\" ";
                        } else {
                            return '';
                        }
                    }

                    function createFuncAttr(innerAttr, funcArgs, dateTimeAttrOpt) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + dateTimeAttr + "({" + funcArgs + "})\" ";
                        } else {
                            return '';
                        }
                    }

                    function createEvalAttr(innerAttr, dateTimeAttrOpt, append) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + attrs[dateTimeAttr] + (append ? ' ' + append : '') + "\" ";
                        } else {
                            return dashCase(innerAttr) + "=\"" + (append || '') + "\" ";
                        }
                    }

                    function createAttrConcat(previousAttrs, attr) {
                        return previousAttrs + createAttr.apply(null, attr);
                    }
                    
                    var tmpl = "<div class=\"nowrap\"><div class=\"col-xs-6 no-padding\" "
                        + createEvalAttr("ngClass", "datePartClass")
                        + " style=\"display:inline-block\">\n"
                        + "<div class=\"input-group" + (small ? ' input-group-sm\">' : '\">')
                        + "<input "
                        + createEvalAttr("class", "dateInputClass", 'form-control date-picker-input')
                        + " type=\"text\" ng-click=\"open($event)\" is-open=\"opened\" ng-model=\"ngModel\" datepicker-Options=\"extendedDateOptions\" datepicker-append-to-body=\"true\" "
                        + [
                            ["minDate"],
                            ["maxDate"],
                            ["dayFormat"],
                            ["monthFormat"],
                            ["yearFormat"],
                            ["dayHeaderFormat"],
                            ["dayTitleFormat"],
                            ["monthTitleFormat"],
                            ["startingDay"],
                            ["yearRange"]
                        ].reduce(createAttrConcat, '')
                        + createFuncAttr("dateDisabled", "date: date, mode: mode")
                        + createEvalAttr("uibDatepickerPopup", "dateFormat")
                        + createEvalAttr("placeholder", "placeholder")
                        + " readonly />\n" +
                        "<span class=\"input-group-btn date-picker-btn\">" +
                        '<a class="btn btn-default' + '" ng-click="open($event)"><i class="glyphicon glyphicon-calendar"></i></a>' +
                        "</span>\n" +
                        "</div>\n" +
                        "</div>\n" +
                        "<div class=\"col-xs-6 no-padding\" " +
                        createEvalAttr("ngClass", "timePartClass") +
                        " style=\"display:inline-block\">\n" +
                        "<" + (small ? 'small-' : '') + "popup-timepicker ng-model=\"time\" id=\"timePicker\" is-open=\"timeOpen\" ng-change=\"time_change()\" " + [
                            ["hourStep"],
                            ["minuteStep"],
                            ["showMeridian"],
                            ["meredians"],
                            ["mousewheel"]
                        ].reduce(createAttrConcat, '') +
                        "></popup-timepicker>\n" +
                        "</div>" +
                        '<span ng-if="showClear"><a href="" class="btn btn-danger' + (small? ' btn-sm':'') + '" ng-click="clear()" >{{clearText || "Clear"}}</a></span>' +
                        "</div>";
                    return tmpl;
                },
                controller: [
                    '$scope', '$rootScope',
                    function ($scope, $rootScope) {

                        $scope.extendedDateOptions = angular.extend($scope.dateOptions || {}, {
                            'datetimePickerUpdate': '$parent.$parent.updatePromise',
                            'datetimePickerLoading': '$parent.$parent.dateLoading'
                        });

                        function closeOtherPickers() {
                            $scope.ignoreCloseEvent = true;
                            $rootScope.$broadcast('datetimePickerOpened');
                            $scope.ignoreCloseEvent = false;
                        };

                        // usar un evento para cerrar todos los pickers que no sean el que se está abriendo
                        $scope.$on('datetimePickerOpened', function closePickers() {
                            if (!$scope.ignoreCloseEvent) {
                                $scope.opened = false;
                                $scope.timeOpen = false;
                            }
                        });
                        
                        $scope.clear = function () {
                            $scope.oldModelo = $scope.ngModel;
                            $scope.ngModel = undefined;
                        };

                        $scope.restore = function () {
                            if ($scope.oldModelo && $scope.ngModel == undefined) {
                                $scope.ngModel = $scope.oldModelo;
                            } else if ($scope.ngModel == null) {
                                var date = new Date();
                                date.setHours(0);
                                date.setMinutes(0);
                                date.setSeconds(0);
                                date.setMilliseconds(0);
                                $scope.ngModel = convertLocalDateToUTCDate(date);
                            }
                        };

                        $scope.updateDatePickerModel = function updateDatePickerModel() {
                            // cuando cambia el tiempo lo seteo al modelo del datePicker
                            if ($scope.time) {
                                $scope.restore();
                                // convert from ISO format to Date
                                if (typeof $scope.ngModel == "string")
                                    $scope.ngModel = new Date($scope.ngModel);
                                $scope.ngModel.setHours($scope.time.getHours(), $scope.time.getMinutes());
                            }
                        };

                        $scope.updateTimePickerModel = function updateTimePickerModel(ngModelValue) {
                            // si se modifica el modelo y no esta abierto el timePicker cambio el modelo de time
                            if ($scope.timeOpen)
                                return;

                            if (ngModelValue)
                                $scope.time = new Date(ngModelValue);
                            else
                                $scope.time = null;
                        };

                        $scope.modelChanged = function (ngModelValue) {
                            $scope.ngChange();
                            $scope.updateTimePickerModel(ngModelValue);
                        };

                        $scope.open = function open($event) {
                            $scope.restore();
                            $event.preventDefault();
                            $event.stopPropagation();
                            $scope.opened = true;
                            $scope.timeOpen = false;
                            closeOtherPickers();
                        };

                        $scope.$watch('timeOpen', function (value) {
                            if (value) {
                                // cierro el date picker si se abre el de tiempo
                                $scope.opened = false;
                                closeOtherPickers();
                            } else {
                                $scope.updateDatePickerModel();
                            }
                        });
                    }
                ],
                link: function ($scope, element) {
                    $scope.$watch('time', $scope.updateDatePickerModel, true);
                    $scope.$watch('ngModel', $scope.modelChanged, true);
                }
            };
        };
    };

    angular.module("DateTimePicker")
        .directive('datetimePickerUpdate', function () {
            var noop = function () {
            };
            return {
                require: 'datepicker',
                link: function (scope, elem, attrs, dpCtrl) {
                    var refreshPromise = scope.$eval(attrs.datetimePickerUpdate);
                    if (refreshPromise) {
                        refreshPromise.then(noop, noop, function() {
                            dpCtrl.refreshView();
                        });
                    }
                }
            };
        })
        .directive('datetimePickerLoading', ["$compile", function ($compile) {
            return {
                restrict: 'A',
                link: function ($scope, element, attr, controller) {
                    
                    var loadingEl = angular.element("<div ng-show=\"" + attr.datetimePickerLoading + "\" class=\"date-picker-loading\"></div>");

                    var elem = element.append(loadingEl);

                    $compile(loadingEl)($scope);
                }
            }
        }])
        .directive('uibDatepickerPopup', function () {
            return {
                restrict: 'EAC',
                require: 'ngModel',
                link: function ($scope, element, attr, controller) {
                    //remove the default formatter from the input directive to prevent conflict
                    controller.$formatters.shift();
                }
            }
        })
        .directive('datetimePicker', createDateTimePickerFactory(false))
        .directive('smallDatetimePicker', createDateTimePickerFactory(true));
})();
